export const teamResourceGridProps = {
    responsiveColumns: true,
    responsiveWidthOffset: 300,
    colGap: 20,
    rowGap: 20,
} as const;
